const doc = [({"ko":({"adminConstantBookingPayTypeShort":({"creditCard":"신용 카드", "onSite":"현장"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;